import React, { Component } from 'react';
// import logo from './rrlogo-1.30.17.png';
// import logo from './Logo-FurnishedLivingLA-3.9.png';
//import logo from './logo-eqlbox.png';
import logo from './furnishedlivingla-logo-71618.png';

import fbLogoHeader from './FB-f-Logo__white_58.png'
//import taLogoHeader from './ta-logo-rr-0.png'
import mlsLogoHeader from './mls-logo-rr.png'
import { Link } from 'react-router-dom';
import FaPhone from 'react-icons/lib/fa/phone';
import MdEmail from 'react-icons/lib/md/email';
import FaGoogle from 'react-icons/lib/fa/google';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import IoHelpCircled from 'react-icons/lib/io/help-circled';
import SEOHiddenText from './SEOHiddenText';


class Navbar3 extends Component {
  constructor(props, context){
    super(props)
    this.navOpacity = this.navOpacity.bind(this)
    this.menuClick = this.menuClick.bind(this)
    this.handleOnClick = this.handleOnClick.bind(this)
    this.logoClick = this.logoClick.bind(this)
    this.state = initialState;
  }
  componentDidMount(){
    window.addEventListener('scroll', this.navOpacity)
  }
  componentWillUnmount(){
    window.removeEventListener('scroll', this.navOpacity)
  }
  checkBodyScroll(e){
    // var body = document.getElementsByTagName('body');
    // if(window.innerWidth > 775 &&){
    //     body.classList.remove("body-no-scroll")
    // }
  }
  handleOnClick(x){
    const { match, location, history } = this.props
    history.push(x)
    this.menuClick()
  }
  logoClick(){
      if(!this.state.phoneEmailClosed) this.phoneEmailModal()
      if(!this.state.navClosed) this.menuClick()
  }
  navShrink(){
    this.setState({navOpacity: 1, navOpaque: true, navTextBlack: true, navHeight: 65, navImageWidth: 200, shrunkNav: true})
  }
  navExpand(){
    this.setState({...initialState})
  }
  navOpacity(){
    if(window.pageYOffset > 5 && !this.state.navHidden){
      this.setState({navHidden: true})
    }
    if(window.pageYOffset < 5 && this.state.navHidden){
      this.setState({navHidden: false})
    }
    if(window.pageYOffset < this.state.scrollPosition){
      this.setState({direction: 2, scrollPosition: window.pageYOffset})
    } else {
      this.setState({direction: 1, scrollPosition: window.pageYOffset})
    }
  }
  menuClick(){
    var t = this, s = this.state, addBodyClass = "body-scroll-nav", removeBodyClass = "body-no-scroll-nav"
    var drift = document.getElementById('drift-widget')
    if(this.state.navClosed){
      addBodyClass = "body-no-scroll-nav"
      removeBodyClass = "body-scroll-nav"
      if(drift) drift.style.display = "none"
    } else {
      if(drift) drift.style.display = "block"
    }
    t.setState({navClosed: !s.navClosed, phoneEmailClosed: true})
    document.body.classList.add(addBodyClass)
    document.body.classList.remove(removeBodyClass)
  }
  phoneEmailModal(){
    var t = this, s = this.state, addBodyClass = "body-scroll-nav", removeBodyClass = "body-no-scroll-nav", drift = document.getElementById('drift-widget');
    //if phoneEmailMenu is close
    if(this.state.phoneEmailClosed){
      addBodyClass = "body-no-scroll-nav"
      removeBodyClass = "body-scroll-nav"
      if(drift) drift.style.display = "none"
    } else {
      if(drift) drift.style.display = "block"
    }
    this.setState({navClosed: true, phoneEmailClosed: !s.phoneEmailClosed})
    document.body.classList.add(addBodyClass)
    document.body.classList.remove(removeBodyClass)
  }
  openLink(x){
    window.open(x, "_blank");
  }
  render(){
    // const { match, location, history } = this.props
    // var t = this, s = this.state, openClose = Boolean(s.navClosed || s.phoneEmailClosed) ? "close3" : "open3", navTextColor = s.navTextBlack ? "black-font3" : "white-font3", menuClass = openClose + " " + "menuitems3" + " " + navTextColor, opacity = s.navOpacity, newHeight = !s.navClosed ? 258 : s.navHeight;
    // var menuClass = openClose + " " + "menuitems3", opacity = s.navOpacity, navTextColor = s.navTextBlack ? "nav-container3 black-font3" : "nav-container3 white-font3";
    var t = this, s = this.state, openClose = s.navClosed ? "close3" : "open3", menuClass = openClose + " " + "menuitems3", opacity = s.navOpacity, navTextColor = s.navTextBlack ? "nav-container3 black-font3" : "nav-container3 white-font3";
    var navStyle = function(){if(s.navHidden){return {top: '-90px'}}else{return {top: '0px'}}}();
    // var t = this, s = this.state, openClose = s.navClosed ? "close" : "open", menuClass = openClose + " " + "menuitems", opacity = s.navOpacity, navTextColor = s.navTextBlack ? "nav-container black-font" : "nav-container white-font";
    //phoneEmailModal open/close
    var phoneEmailModal = "display-none";
    if(!s.phoneEmailClosed){
        phoneEmailModal = "display-block phone-email-modal-class";
        openClose = openClose + " phone-email-modal-open-below";
    }

    if(this.props.changeClass === true){
      navStyle.backgroundColor = 'rgba(0,0,0,0.0)';
    }
    if(s.direction === 2 || Boolean(this.props.changeClass === false && window.pageYOffset >= 5)){
      navStyle = {top: '0px', backgroundColor: 'rgba(0,0,0,0.8)'};
    }
    if(window.pageYOffset < 5 && this.props.changeClass !== false){
      navStyle = {top: '0px', backgroundColor: 'rgba(0,0,0,0.0)'};
    }
    if(this.props.changeClass === false){
      navStyle.backgroundColor = 'rgba(0,0,0,0.8)';
    }

    return (
      <div>
        <nav id="nav-bar3" className={openClose} style={{boxShadow: "0px 4px 4px -3px rgba(35, 35, 35," + opacity + ")", ...navStyle}}>
          <div className="flex-container visible-xs height-100">
            <div id="hamburger3" className={openClose} onClick={this.menuClick}>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div className="mobile-nav-logo-container" onClick={this.logoClick}>
              <Link to ="/"><img id="logo-homepage"className="white" src={logo} alt="Furnished Living Los Angeles"/></Link>
            </div>
            <a id="hidden-phone-number2" className="header-what-we-do-text" href="tel:+14242584690">(424) 258-4690</a>
            <div id="mobile-phone" onClick={() => this.phoneEmailModal()}><IoHelpCircled className="phoneMobile" /></div>
          </div>
          <div className="header flex-container flex-direction-row">
            <div className="nav-logo-container">
              <Link to ="/"><img id="logo-homepage"className="white" src={logo} alt=""/></Link>
            </div>
            <div className="contactInfoContainer">
              <div className="tk-proxima-nova residentsContainer leftContainer" onClick={() => document.getElementById('hidden-phone-number').click()}>
                <div className="inline-block"><FaPhone className="phoneFontNavbar" />(424) 258-4690
                </div>
              </div>
              <div className="tk-proxima-nova residentsContainer" onClick={() => document.getElementById('hidden-email').click()}>
                <div className="inline-block">
                    <MdEmail className="emailFontNavbar" />info@furnishedlivingla.com
                </div>
              </div>
            </div>
          </div>
          <div className="navigation-items-container flex-container">
            <div className="desktop-nav-item">
              <Link to={"/floor-plans"}>Floor Plans<div><span></span></div></Link>
            </div>
            <div className="desktop-nav-item">
              <Link to={"/gallery"}>Gallery<div><span></span></div></Link>
            </div>
            <div className="desktop-nav-item">
              <Link to={"/amenities"}>Amenities<div><span></span></div></Link>
            </div>
            <div className="contactInfoContainer">
              <div className="navbar-icon-container fb-icon-container">
                <a href="https://www.facebook.com/furnishedlivingla/" target="_blank"><img id="fb-header" style={{width: "15px"}} src={fbLogoHeader} alt=""/></a>
              </div>
              <div className="navbar-icon-container fb-icon-container google-icon-container" onClick={() => this.openLink("https://goo.gl/maps/qhDqWKfUREs")}>
                <FaGoogle className="googleIconFontNavbar" />
              </div>
              <div className="navbar-icon-container">
                <Link onClick={() => this.openLink("http://www.themls.com/Dashboards/sharedListings/umy8HDsQE6Z5fheGi8l-js4XZnaxeEOy0")} to="/"><img id="ta-header" style={{width: "22px"}} src={mlsLogoHeader} alt=""/></Link>
              </div>
            </div>
          </div>
          <ul className="mobile-list3">
            <li onClick={() => this.handleOnClick('floor-plans')}><a className={menuClass}>Floor Plans</a></li>
            <li onClick={() => this.handleOnClick('gallery')}><a className={menuClass}>Gallery</a></li>
            <li onClick={() => this.handleOnClick('amenities')}><a className={menuClass}>Amenities</a></li>
          </ul>
          <ul className={phoneEmailModal} style={{height: 'calc(100vh - 60px)'}}>
            <li><a href="tel:+14242584690" className="phone-email-modal-menu-text">(424) 258-4690</a></li>
            <li><a href="mailto:info@furnishedlivingla.com" className="phone-email-modal-menu-text">info@furnishedlivingla.com</a></li>
          </ul>
        </nav>
      </div>
    );
  }
}


var arr = [
  {title: false, resizeNav: this.expandNav},
  {title: "Floor Plans"},
  {title: "Gallery"},
  {title: "Contact"},
  {title: "Residents"},
  {title: "Availability"},
  {title: "(424) 258-4690"}
];

const initialState = {
  navClosed: true, // true --> hamburger (closed menu) | false --> x (open menu)
  phoneEmailClosed: true, // true --> phoneEmailModal closed | false --> phoneEmailModal closed
  navOpaque: false,
  navOpacity: 0,
  navTextBlack: false,
  navHeight: 125,
  navImageWidth: 240,
  shrunkNav: false,
  scrollPosition: window.pageYOffset,
  direction: 1,
  navigate: false,
  link: '/'
}

export default withRouter(Navbar3);



// WEBPACK FOOTER //
// ./src/Navbar3.js